import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface LicenseListItemDTO {
  id: string;
  licenseNumber: string;
  pos: string;
  sms: string;
  asset: string;
  product: string;
  location: string;
  activatedDate: moment.Moment | null;
  activated: boolean;
  disabled: boolean;
  details: string; // will be a string of text to display in a pop up.  Needs to be in format we can copy from and display multiple lines |
}
const LicenseListItemDTO = {
  create: (initValues?: Partial<LicenseListItemDTO>): LicenseListItemDTO => {
    const defaults: LicenseListItemDTO = {
      id: '',
      licenseNumber: '',
      pos: '',
      sms: '',
      asset: '',
      product: '',
      location: '',
      activatedDate: null,
      activated: false,
      disabled: false,
      details: '',
    };
    const fixedInitValues: Partial<LicenseListItemDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
        activatedDate: ObjectUtil.ToMoment(initValues.activatedDate),
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default LicenseListItemDTO;
